var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorfulPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtract",
    filter: "url(#filter0_ii_465_2613)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9375 4.5835C10.7284 4.5835 8.9375 6.37435 8.9375 8.58349V46.4168C8.9375 48.626 10.7284 50.4168 12.9375 50.4168H42.0625C44.2716 50.4168 46.0625 48.626 46.0625 46.4168V16.0418L34.6042 4.5835H12.9375Z",
    fill: "#FA4E4E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.9436 35.4507C33.397 35.3359 31.908 34.7615 30.7052 33.7277C28.3568 34.2445 26.1227 34.991 23.8889 35.9102C22.1134 39.069 20.4523 40.6772 19.0203 40.6772C18.7338 40.6772 18.3903 40.6199 18.1612 40.4474C17.531 40.1604 17.1875 39.5285 17.1875 38.8968C17.1875 38.3798 17.3021 36.944 22.7434 34.5891C24.0038 32.2917 24.9772 29.937 25.7792 27.4674C25.0917 26.089 23.6027 22.7002 24.6334 20.9774C24.9772 20.3455 25.6647 20.0009 26.4095 20.0585C26.9821 20.0585 27.5547 20.3455 27.8985 20.805C28.6433 21.8388 28.586 24.0213 27.612 27.2377C28.5287 28.9583 29.7293 30.5117 31.1632 31.8325C32.3664 31.6025 33.5689 31.4303 34.7717 31.4303C37.4639 31.4876 37.8649 32.7512 37.8076 33.4979C37.8076 35.4507 35.9173 35.4507 34.9436 35.4507ZM18.906 39.0114L19.0778 38.9541C19.8796 38.6671 20.5096 38.0927 20.9679 37.3459C20.1085 37.6906 19.4213 38.2649 18.906 39.0117V39.0114ZM26.5238 21.7815H26.3519C26.2946 21.7815 26.18 21.7815 26.1227 21.8388C25.8935 22.8151 26.0654 23.8489 26.4665 24.7678C26.8102 23.7916 26.8102 22.7578 26.5238 21.7815ZM26.9248 30.1094L26.8675 30.224L26.8102 30.1667C26.2946 31.4879 25.7217 32.8087 25.0917 34.0723L25.2063 34.015V34.1296C26.4801 33.6678 27.7808 33.2842 29.1013 32.9809L29.044 32.9236H29.2159C28.3565 32.0619 27.5547 31.0857 26.9248 30.1094ZM34.7145 33.1533C34.1988 33.1533 33.7408 33.1533 33.2252 33.2679C33.7981 33.5552 34.371 33.6701 34.9436 33.7277C35.3447 33.785 35.7457 33.7277 36.0892 33.6128C36.0892 33.4404 35.86 33.1533 34.7145 33.1533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1",
    d: "M44.9873 14.9673L35.6782 14.9673L46.0623 25.3514L46.0623 16.0415L44.9873 14.9673Z",
    fill: "url(#paint0_linear_465_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1",
    d: "M46.0625 16.0415L34.6042 4.58317C34.6042 10.9114 39.7342 16.0415 46.0625 16.0415Z",
    fill: "#FDB8B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_465_2613",
    x: 8.9375,
    y: 3.5835,
    width: 37.125,
    height: 47.8335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_465_2613"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_465_2613",
    result: "effect2_innerShadow_465_2613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_465_2613",
    x1: 38.0057,
    y1: 12.6398,
    x2: 48.3898,
    y2: 23.0239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorfulPdfIcon);
export default __webpack_public_path__ + "static/media/colorful-pdf-icon.79a843a474fdec2f351f292254708f38.svg";
export { ForwardRef as ReactComponent };